import {management} from '../../../../index'
import {FarmsDapRepository} from "../../../infra/knex/repositories/farmsDapRepository"

import {GeLastRecordFromFarmDapUseCase} from "./getLastRecordFromFarmDAP"


export const getFarmDapByLastRecordUseCase=()=>{
  const farmsDapRepository= new FarmsDapRepository(management)

  const getFarmDapByLastRecordUseCase=new GeLastRecordFromFarmDapUseCase(farmsDapRepository)
  return getFarmDapByLastRecordUseCase
}
